import { FootNoteRun } from '../../../../../common/model/runs/simple-runs';
import { RichUtils } from '../../../../../common/model/rich-utils';
import { NotesImporter } from './notes-importer';
export class FootNotesImporter extends NotesImporter {
    insertRun(subDocId) {
        const pos = this.data.subDocumentInfo.positionImporter.currPosition;
        const run = new FootNoteRun(pos, this.data.subDocumentInfo.paragraphImporter.paragraph, this.data.subDocumentInfo.characterImporter.charPropsBundle, subDocId);
        this.data.subDocumentInfo.characterImporter.addRun(run, RichUtils.specialCharacters.LayoutDependentText);
    }
}
